import React, { useState } from 'react';
import moment from "moment";
import { Form, DatePicker, Card, Typography, Image, Input, InputNumber } from 'antd';
import Button from '@mui/material/Button';

import { money } from '../../../../utils/strings';

const { Title } = Typography;

const InfoEntry = ({ value = {}, onChange, onNext, inlineView=false }) => {
  // Keep everything local in the child component
  const [formState, setFormState] = useState(value);

  // Update local state only
  const handleFieldChange = (field, newValue) => {
    setFormState((prev) => ({
      ...prev,
      [field]: newValue
    }));
  };

  // Called only on “Submit” to send data up to parent
  const handleSubmit = () => {
    onChange?.(formState);
    onNext?.();
  };

  // Example: storing date as a plain JS Date
  const handleDateChange = (date) => {
    // Convert to plain JS date or store the year, whichever you need
    handleFieldChange('birthYear', date?.toDate() || null);
  };

  return (
    <div className="w-full max-w-3xl mx-auto">
      <Card bordered={false} className="shadow-none">
        <Form layout="vertical">
          {/* Main Info Section */}
          <div className="grid grid-cols-2 gap-x-8 gap-y-6 mb-8">
            <Form.Item label="Client Name" className="mb-0">
              <Input
                value={formState.name || ''}
                onChange={(e) => handleFieldChange('name', e.target.value)}
                className="w-full h-12"
                placeholder="Enter client name"
              />
            </Form.Item>

            <Form.Item label="Email (Optional)" className="mb-0">
              <Input
                value={formState.email || ''}
                onChange={(e) => handleFieldChange('email', e.target.value)}
                className="w-full h-12"
                placeholder="Client email address"
                type="email"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
              />
            </Form.Item>

            <Form.Item label="Birth Year" className="mb-0">
              <DatePicker
                value={formState.birthYear ? moment(formState.birthYear) : null}
                onChange={handleDateChange}
                picker="year"
                className="w-full h-12"
                placeholder="Select birth year"
              />
            </Form.Item>

            <Form.Item
              label={
                <span>
                  Initial Value{' '}
                  {formState?.initialValue > 0 && money(formState.initialValue, 0)}
                </span>
              }
              className="mb-0"
            >
              <InputNumber
                min={50000}
                max={1e12}
                step={50000}
                value={formState.initialValue || undefined}
                onChange={(val) => handleFieldChange('initialValue', val)}
                className="w-full py-2"
                placeholder="Initial Value ($)"
              />
            </Form.Item>
          </div>

          {/* Riskalyze Score Section */}
          <div className="grid grid-cols-2 gap-8 items-center">
            <div className="flex justify-center items-center bg-gray-50 rounded-lg p-6">
              <Image
                src="https://storage.googleapis.com/finiat-web-static-resources/third-party-brands/nitrogen-logo.png"
                height={48}
                width="auto"
                preview={false}
                className="rounded-lg"
              />
            </div>

            <Form.Item label="Risk Score (Optional)" className="mb-0">
              <InputNumber
                min={1}
                max={99}
                value={formState.riskalyzeScore || undefined}
                onChange={(val) => handleFieldChange('riskalyzeScore', val)}
                className="w-full py-2"
                placeholder="Enter score (1-99)"
              />
            </Form.Item>
          </div>

          {/* Submit Button */}
          {!inlineView && (
              <div className="flex justify-end mt-4">
                <Button variant={'outlined'} className={'pill'} size={'large'} onClick={handleSubmit}>
                  <span className={'text-2xl'}>
                    Continue
                  </span>
                </Button>
              </div>
          )}
        </Form>
      </Card>
    </div>
  );
};

export default InfoEntry;
